import { useEffect, useMemo } from "react"

import { FilterCategory } from "config/constants"
import { useTenantSettings } from "stores/tenantSettings"

export default function useTenantEmployeeOptions(currentFilterCategory: FilterCategory) {
    const {
        tenantEmployees,
        fetchTenantEmployees,
    } = useTenantSettings()

    const tenantEmployeeOptions = useMemo(() => {
        return tenantEmployees?.entities.map(sa => ({
            label: sa.fullName,
            value: sa,
        }))
    }, [tenantEmployees])

    useEffect(() => {
        if (!tenantEmployees && (
            currentFilterCategory === FilterCategory.salesAdmin
            || currentFilterCategory === FilterCategory.salesPerson
        )) {
            fetchTenantEmployees()
        }
    }, [currentFilterCategory, fetchTenantEmployees, tenantEmployees])

    return {
        tenantEmployeeOptions,
    }

}
